import FaceIcon from '@material-ui/icons/Face'

export default FaceIcon
